import React,{useState,useEffect} from "react";
import { useConverter } from "./hooks/useConverter";
import {ArrowLeftRight,Scale,Ruler,Globe} from 'lucide-react';
import './App.css';

function App(){
    const{convert,rates,loading,units}=useConverter();
    const[mode, setMode]=useState("Currency");
    const[val1,setVal1]=useState(1);
    const[val2,setVal2]=useState('');
    const[unit1, setUnit1]=useState("USD");
    const[unit2, setUnit2]=useState("INR");
    useEffect(()=>{
      setVal2(convert(val1,unit1,unit2,mode));
    }, [val1,unit1,unit2,mode,convert]);

    const handleModeChange=(newMode)=>{
      setMode(newMode);
      if(newMode==="Currency"){setUnit1("USD"); setUnit2("INR");}
      else if(newMode==="Length"){setUnit1("meter"); setUnit2("km");}
      else if(newMode==="Weight"){setUnit1("kg"); setUnit2("pound");}
};return (
    <div className="app-container">
      <header>
        <h1><ArrowLeftRight size={32} color="#8b5cf6" /> MultiConvert</h1>
        <div className="tab-group">
          <button className={mode === 'Currency' ? 'active' : ''} onClick={() => handleModeChange('Currency')}><Globe size={18}/> Currency</button>
          <button className={mode === 'Length' ? 'active' : ''} onClick={() => handleModeChange('Length')}><Ruler size={18}/> Length</button>
          <button className={mode === 'Weight' ? 'active' : ''} onClick={() => handleModeChange('Weight')}><Scale size={18}/> Weight</button>
        </div>
      </header>
      <div className="glow-container">
  <div className="blob blob-1"></div>
  <div className="blob blob-2"></div>
</div>

      {loading && mode === 'Currency' ? <p>Updating rates...</p> : (
        <div className="converter-card">
          <div className="input-group">
            <input type="number" value={val1} onChange={(e) => setVal1(e.target.value)} />
            <select value={unit1} onChange={(e) => setUnit1(e.target.value)}>
              {mode === 'Currency' ? Object.keys(rates).map(c => <option key={c} value={c}>{c}</option>)
              : Object.keys(units[mode]).map(u => <option key={u} value={u}>{u}</option>)}
            </select>
          </div>

          <div className="divider">=</div>

          <div className="input-group">
            <input type="number" value={val2} readOnly />
            <select value={unit2} onChange={(e) => setUnit2(e.target.value)}>
              {mode === 'Currency' ? Object.keys(rates).map(c => <option key={c} value={c}>{c}</option>)
              : Object.keys(units[mode]).map(u => <option key={u} value={u}>{u}</option>)}
            </select>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
